import React, { Component } from "react";
import _ from 'i18n';
import {Col, Row} from "antd";
import EventProgressBar from "./EventProgressBar";
import moment from "moment";
import EventCharts from "./EventCharts";


export default class CycleDataTableRow extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
    };

  }

  handleChevronDownClick = () => {
    this.setState({
      isActive: !this.state.isActive,
    });
  };

  render() {
    const { isActive } = this.state;
    const { event }= this.props;

    const startTime = moment(event.startDateTime);
    const endTime = moment(event.endDateTime);
    const dateHelper = `${_('from_time')} ${startTime.format('HH:mm')} ${_(
      'to_time',
    )} ${endTime.format('HH:mm')}`;

    const registrants = event.paidRegistrant + event.notPaidRegistrant;



    return (
      <div className={"event-stats-row-container cycle-stats-row-container"}>
        <Row className="event-stats-row" justify="space-around">
          <Col span={1} className={'event-stats-blue-border'}><div className='event-stats-row-border'></div></Col>
          <Col span={3} className="event-stats-date">{startTime.locale('fr').format('ll')} <br /> {dateHelper}</Col>
          <Col span={7}>
            <div className="event-stats-title mb-1">{event.eventName}</div>
            <div className="event-stats-speaker">1 {_('registering')}</div>
          </Col>
          <Col offset={1} span={3}>
            {(registrants === null || registrants === 0 || event.paidRegistrant === 0) ? (
              <EventProgressBar progress={0} number={event.paidRegistrant} cycleRegistrant={null} />
            ) : (
              <EventProgressBar progress={(event.paidRegistrant / registrants) * 100} number={event.paidRegistrant} cycleRegistrant={null} />
            )}
          </Col>

          <Col offset={1} span={3}>
            {(registrants === null || registrants === 0 || event.notPaidRegistrant === 0) ? (
              <EventProgressBar progress={0} number={event.notPaidRegistrant} cycleRegistrant={null} />
            ) : (
              <EventProgressBar progress={(event.notPaidRegistrant / registrants) * 100} number={event.notPaidRegistrant} cycleRegistrant={null} />
            )}
          </Col>
          <Col offset={1} span={4}>
            <div
              className="event-stats-title event-stats-col-total">{registrants} {registrants > 1 ? _('REGISTRATIONS') : _('REGISTRATION')}
              <div className={'ml-auto'}><img src="/img/icons/chevron-down.svg"
                                              onClick={this.handleChevronDownClick}
                                              className={isActive ? "event-stats-chevron-down event-stats-chevron-rotate" : "event-stats-chevron-down"}/>
              </div>
            </div>
          </Col>
        </Row>
        {isActive && (
          <div>
            <img src="/img/icons/hr.svg" className="event-stats-hr"/>
            <div className="event-stats-title event-stats-details">{_('DETAILS')}</div>
            <EventCharts event={event}/>
          </div>
        )}
      </div>
    );
  }
}






// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/CycleDataTableRow.js